const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

const NURSING_FAQS = [
  { q: "Can I request a male or female nurse for home care in Bangalore?", a: "Yes — both male and female home nurses are available based on patient preference and availability." },
  { q: "How much does home nursing cost in Bangalore?", a: "Our packages start from ₹999/day, with the final cost depending on the type of care, duration, and medical complexity." },
  { q: "Do you provide 24-hour nursing care at home?", a: "Yes — nurses can be arranged for round-the-clock or scheduled shift-based care depending on your needs." },
  { q: "How quickly can a nurse be arranged?", a: "Same-day in most cases — our average turnaround time is within 24 hours of your request." },
];

const ELDER_FAQS = [
  { q: "What's the difference between day care and 24-hour elder care?", a: "Day care covers structured daytime support (e.g. 8am–8pm), while 24-hour care provides round-the-clock supervision and assistance." },
  { q: "Do you provide caretakers for elderly parents whose children live abroad?", a: "Yes — we regularly coordinate elder care in Bangalore for families based overseas, keeping them updated and arranging everything locally on their behalf." },
  { q: "What does elder care cost in Bangalore?", a: "Packages start from ₹999/day and vary based on the level of care and hours required — get in touch for a plan suited to your needs." },
  { q: "Which areas of Bangalore do you serve?", a: "We provide elder care across all of Bangalore, regardless of location." },
];

const POSTOP_FAQS = [
  { q: "Do you provide physiotherapy as part of post-surgery home care?", a: "Yes — physiotherapy is available as part of a structured recovery plan after surgery." },
  { q: "Can you coordinate post-surgery care for parents if I live outside India?", a: "Yes — we coordinate post-operative care in Bangalore for families living abroad, managing everything locally so you can stay updated from wherever you are." },
  { q: "How soon after surgery can home care start?", a: "In most cases, same-day — our average turnaround from request or hospital discharge is within 24 hours." },
  { q: "How much does post-operative home care cost?", a: "Packages start from ₹999/day, depending on the type and intensity of post-surgery care needed." },
];

export const SEO_CONTENT = {
  "nursing-care": {
    title: "Home Nursing Services in Bangalore | 24-Hour Care | Healthsqur",
    description: "Professional home nursing care in Bangalore — wound care, medication support, 24-hour & on-demand nurses. Male and female nurses available. Book today.",
    h1: "Home Nursing Services in Bangalore",
    sections: [
      {
        h2: "What Our Home Nursing Services Include",
                subs: [
          { h3: "Wound Care & Dressing", body: "Our trained nurses provide professional wound care and dressing at home, following hospital-standard hygiene and safety practices." },
          { h3: "Medication Management", body: "We help manage medication schedules accurately and safely, so patients never miss a dose and families don't have to worry about timing." },
          { h3: "24-Hour & On-Demand Nursing", body: "Whether you need round-the-clock support or a nurse for a few hours, we arrange care based on what your situation actually requires." },
        ],
      },
      { h2: "Male and Female Home Nurses in Bangalore", body: "Yes — both male and female home nurses are available based on patient preference and availability." },
      { h2: "Home Nursing Cost in Bangalore", body: "Our packages start from ₹999/day, with the final cost depending on the type of care, duration, and medical complexity." },
      { h2: "We Cover All of Bangalore", body: "We provide home nursing services across all of Bangalore, regardless of location." },
    ],
    faqs: NURSING_FAQS,
    schema: faqSchema(NURSING_FAQS),
  },
  "elder-care": {
    title: "Elder Care Services in Bangalore | At-Home Senior Care | Healthsqur",
    description: "Compassionate elder care at home in Bangalore. Daily assistance, caretakers, 12-hour & 24-hour options for senior citizens. Trusted by local families.",
    h1: "Elder Care Services in Bangalore",
    sections: [
      {
        h2: "Elderly Care at Home — What We Provide",
                subs: [
          { h3: "Daily Living Assistance", body: "Our caregivers support daily routines — bathing, dressing, mobility, and meals — with dignity and patience." },
          { h3: "Companionship & Supervision", body: "Beyond physical care, our caregivers provide companionship and keep a close eye on safety and wellbeing throughout the day." },
          { h3: "Medical & Caretaker Support", body: "Our team supports medication schedules, basic health monitoring, and coordination with family or doctors as needed." },
        ],
      },
      { h2: "Day Care vs 24-Hour Elder Care", body: "Depending on your family's routine, we offer structured daytime support or full round-the-clock care — whichever fits your situation best." },
      { h2: "12-Hour and 24-Hour Elder Care Options", body: "Care can be arranged in 12-hour shifts or as continuous 24-hour support, based on what your loved one needs." },
      { h2: "Elder Care Cost in Bangalore", body: "Packages start from ₹999/day and vary based on the level of care and hours required — get in touch for a plan suited to your needs." },
    ],
    faqs: ELDER_FAQS,
    schema: faqSchema(ELDER_FAQS),
  },
  "post-operative-care": {
    title: "Post-Surgery Home Care in Bangalore | Recovery Support | Healthsqur",
    description: "Post-operative care at home in Bangalore — wound dressing, physiotherapy & recovery monitoring after surgery. Safe, supervised, hospital-standard care.",
    h1: "Post-Surgery Home Care in Bangalore",
    sections: [
      {
        h2: "Post-Operative Care Services We Offer",
                subs: [
          { h3: "Wound Dressing & Monitoring", body: "We provide careful wound dressing and monitoring at home to support safe healing after surgery." },
          { h3: "Physiotherapy After Surgery", body: "Our physiotherapy support helps patients recover mobility and strength safely, guided by trained professionals." },
          { h3: "Pain Management & Recovery Support", body: "We help manage post-surgery pain and recovery needs, keeping patients comfortable and progressing safely." },
        ],
      },
      { h2: "Coordinating Care for Family Abroad (NRI Families)", body: "Yes — we coordinate post-operative care in Bangalore for families living abroad, managing everything locally so you can stay updated from wherever you are." },
      { h2: "Post-Surgery Care Cost in Bangalore", body: "Packages start from ₹999/day, depending on the type and intensity of post-surgery care needed." },
    ],
    faqs: POSTOP_FAQS,
    schema: faqSchema(POSTOP_FAQS),
  },
};
